import '../styles.scss'
import React from 'react'
import uniqid from 'uniqid'

import { Editor } from 'components/SmartChatView/Fields'
import ReadMoreText from 'components/common/ReadMoreText'

const MessageViewUI = ({ renderType, company, label, placeholder, value, editorOptions, onChangeInner, isNote, error }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <Editor
        isRequired
        id={`editor-${uniqid()}`}
        company={company}
        label={label}
        placeholder={placeholder}
        value={value}
        options={editorOptions}
        onChange={onChangeInner}
        error={error}
      />
    )}
    {renderType === 'preview' && (
      <div className={`action-view__message-preview ${isNote ? 'action-view__message-preview--note' : ''}`}>
        {value.attachments?.map((attachment, index) => attachment.mimeType === 'image' && (
          <figure key={index} className='action-view__message-preview-picture'>
            <img src={attachment.urlLong || attachment.url} alt={attachment.name} />
          </figure>
        ))}
        {(value.content || value.contentHtml) && (
          <div className='action-view__message-preview-content'>
            <ReadMoreText
              mode='lines'
              lines={2}
              customTextClassName='action-view__text'
            >
              {value.content || value.contentHtml}
            </ReadMoreText>
          </div>
        )}
      </div>
    )}
  </div>
)

export default MessageViewUI
